import { Question } from "src/app/features/medical-record/model/question.model";
import { DateTime } from "luxon";

export function prepareWord(value: string | undefined) {
  return value ? value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
}

export function checkVariable(value: any): string | Array<any> | null {

  if (value && value !== null && value !== undefined) {

    if (typeof value === 'object') {

      const arrayAnswers: Array<any> = [];

      value.forEach((item: any) => {

        if (prepareWord(String(item)) !== 'null' && prepareWord(String(item)) !== 'undefined'
          && prepareWord(String(item)) !== '' && prepareWord(String(item)) !== '??'
          && prepareWord(String(item)) !== 'na' && prepareWord(String(item)) !== 'ninfo') {

          arrayAnswers.push(item);
        }

        if (arrayAnswers.length > 0) {

          return (arrayAnswers.length === 1) ? arrayAnswers[0] : arrayAnswers;
        }
        else {

          return null;
        }
      });

      return arrayAnswers.length > 0 ? arrayAnswers : null;
    }
    else {

      if (prepareWord(String(value)) !== 'null' && prepareWord(String(value)) !== 'undefined'
        && prepareWord(String(value)) !== '' && prepareWord(String(value)) !== '??'
        && prepareWord(String(value)) !== 'na' && prepareWord(String(value)) !== 'ninfo') {

        return value.toUpperCase();
      }
      else {

        return null;
      }
    }
  }
  else {

    return null;
  }
}

export function getQuestion(item: Question) {

  return (checkVariable(item?.question) && item?.answer.length > 0 && item?.answer[0] !== '') ? item?.question?.toUpperCase() : null;
}

export function getAnswer(item: Question): any | null {

  const answer = checkVariable(item?.answer);

  if (answer && answer?.length === 1) {

    return (answer[0] !== true && answer[0] !== false) ? answer : item.question;
  }
  else {

    if (answer && answer?.length > 1) {

      return answer;
    }
  }

  return null;
}

export function compareDate(firstDate: Date | null | undefined, lastDate: Date | null | undefined) {
  if (!firstDate || !lastDate) {
    return 'noDatesSent'
  }
  const first = new Date(firstDate);
  const last = new Date(lastDate);
  first.setHours(0, 0, 0, 0);
  last.setHours(0, 0, 0, 0);

  if (first.getTime() === last.getTime()) {
    return 'equal';
  }

  if (first.getTime() < last.getTime()) {
    return 'firstMinor';
  }

  return 'lastMinor';
}

// todo, apagar e usar a que está em date
export function isTodayLegado(date?: Date | null): boolean {

  return date ? date.getDate() === (new Date()).getDate() && date.getMonth() === (new Date()).getMonth() && date.getFullYear() === (new Date()).getFullYear() : false;

}

export function convertStringToDate(date: string | null | undefined) {

  if (date === null || date === undefined) {

    return null;
  }

  const dateString = date;
  const dateParts = dateString.split('/');
  const year = Number(dateParts[0]);
  const month = Number(dateParts[1]) - 1; // O objeto Date considera janeiro como o mês 0
  const day = Number(dateParts[2]);
  return new Date(year, month, day);
}

// Ex : (12.34 , 1) => 12.3 ; (11 , 2) => 11;
export const limitMaxDecimals = (x: number, max: number) => {
  return parseFloat(x.toPrecision(`${Math.ceil(x)}`.length + max))
}

export function formatDate(date: Date | null | undefined | string): string {

  if (date === null || date === undefined) {
    return '';
  }
  let _date : Date = (date instanceof Date) ? date : new Date(date)


  const day = String(_date.getDate()).padStart(2, '0')
  const month = String(_date.getMonth() + 1).padStart(2, '0')
  const year = String(_date.getFullYear()).padStart(2, '0')

    return `${day} / ${month} / ${year}`

}

export function diffBetweenDates(firstDay: Date, finalDay: Date): number {

  const umDiaEmMilissegundos = 24 * 60 * 60 * 1000;
  const diffEmMilissegundos = finalDay.getTime() - firstDay.getTime();
  const diffEmDias = Math.floor(diffEmMilissegundos / umDiaEmMilissegundos);
  return diffEmDias;
}

export const oncoDefaultDateInterval = (date1: Date, date2: Date) => {
  const {firstDate , secondDate} = orderTwoDates(date1 , date2);
  const end = DateTime.fromJSDate(secondDate)
  const start = DateTime.fromJSDate(firstDate)
  const diff = end.diff(start , [ 'years' , 'months' , 'days']);
  
  const years = diff.years > 0 ? `${diff.years} ano${diff.years > 1 ? 's' : ''}` : '';
  const months = diff.months > 0 ? `${diff.months} m${diff.months > 1 ? 'eses' : 'ês'}` : '';
  const days = diff.days > 0 ? `${Math.round(diff.days)} dia${diff.days > 1 ? 's' : ''}` : '';
  
  const formattedDiff = [years, months, days].filter(Boolean).join(', ');

  return formattedDiff;
}


/**
* Calc e formata em string pra usuario diff entre duas datas seguindo padrão
* do sistema [ONCO-3626 ]
* @example
* ```ts
* const date1 = new Date('2024/01/020')
* const date2 = new Date('2024/02/021')
* const diferencaEmTexto = formatIntervalBetweenDates(date1, date2)
* diferencaEmTexto === '1 mês, 1 dia'
* ```
*/
export function formatIntervalBetweenDates(date1: Date  , date2: Date) {
  const diff = oncoDefaultDateInterval(date1 , date2)
  return diff;
}


export const orderTwoDates = (date1: Date , date2: Date) => {
  const date1ms = date1.valueOf()
  const date2ms = date2.valueOf()
  const firstDate = date1ms < date2ms ? date1 : date2
  const secondDate = date1ms < date2ms ? date2 : date1
  return {firstDate , secondDate}
}

